import React from 'react';
import { generatePath } from 'react-router-dom';
import { useNavigate } from 'src/utils/useNavigate';
import Button from 'src/components/Button';
import Text from 'src/components/Text';
import routes from 'src/constants/routes';
import styles from './styles.module.scss';
import Modal from 'src/components/Modal';

type Props = {
  isOpen: boolean;
  onClose: () => void;
  partnerBank?: boolean;
  bankUeid?: string;
  bankName?: string;
  organizationName?: string;
};

const ErrorDialog: React.FC<Props> = ({ isOpen, onClose, partnerBank, bankUeid, bankName, organizationName}) => {
  const navigate = useNavigate();
  
  const handleAddApplication = () => {
    navigate(generatePath(routes.bankApplication, { bankUeid }));
  }
  
  if (partnerBank) {
    return (
      <Modal
        isOpen={isOpen}
        onClose={onClose}
        title="Ошибка добавления банка"
        content={(
          <Text type="p" muted>
            Не найдена информация для подключения оплат через СБП для организации{' '}
            <Text type="span">{organizationName}</Text> в банке <Text type="span">{bankName}</Text>. Рекомендуем
            отправить заявку для заключения договора на СБП с банком.
          </Text>
        )}
        footer={
          <div>
            <Button
              width="available"
              onClick={handleAddApplication}
              className={styles['button']}
            >
              Отправить заявку
            </Button>
            <Button
              width="available"
              variant="outlined"
              onClick={onClose}
              className={styles['button']}
            >
              Отмена
            </Button>
          </div>
        }
      />
    )
  }
  
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title="Ошибка добавления банка"
      content={(
        <Text type="p" muted>
          Не найдена информация для подключения оплат через СБП для организации{' '}
          <Text type="span">{organizationName}</Text> в банке <Text type="span">{bankName}</Text>.
          Обратитесь в банк для заключения договора на СБП.
        </Text>
      )}
      footer={
        <Button onClick={onClose} className={styles['modal-button']}>
          Закрыть
        </Button>
      }
    />
  );
};

export default ErrorDialog;
